import { Component, Input, OnInit } from '@angular/core';

import { SubSink } from 'subsink';
import { ChartConfiguration, ChartType } from 'chart.js';

import { DynamicChartDataService } from '@Services';

import { ChartComponent, CustomDataPoint } from '../chart/chart.component';

interface Filter {
  total_text: string;
  total: string;
  value: string;
  label: string;
  custom_property_name_2: string;
  custom_property_value_2: string;
  filtered_total_text: string;
  filtered_total_value: string;
}

@Component({
  selector: 'app-dynamic-chart',
  imports: [ChartComponent],
  templateUrl: './dynamic-chart.component.html',
  styleUrl: './dynamic-chart.component.css',
  standalone: true,
})
export class DynamicChartComponent implements OnInit {
  @Input() title!: string;
  @Input() description: string | null = null;
  @Input() ngClass!: string;

  @Input() summary_search_parameter_for_charts!: string;
  @Input() url_parameter!: string;
  @Input() main_link_for_chart!: string;
  @Input() filters!: Filter[];
  error: string | null = null;

  chartDataArray: {
    chartData: ChartConfiguration['data'];
    customData: CustomDataPoint[][];
    chartOptions: ChartConfiguration['options'] | undefined;
    chartType: ChartType;
  }[] = [];

  private subs = new SubSink();

  constructor(private dynamicChartDataService: DynamicChartDataService) {}

  ngOnInit() {
    const randomValue = Math.floor(Math.random() * 100);

    // Log the raw input parameters
    console.log('url_parameter:', this.url_parameter);
    console.log('summary_search_parameter_for_charts:', this.summary_search_parameter_for_charts);

    const joinedUrl = this.joinUrl(this.url_parameter, this.summary_search_parameter_for_charts);

    // Log the final joined URL
    console.log('joinedUrl:', joinedUrl);
    this.subs.add(
      this.dynamicChartDataService
        .callApiForArrayV4(
          this.title,
          this.joinUrl(this.url_parameter, this.summary_search_parameter_for_charts),
          this.filters,
        )
        .subscribe({
          next: (data) => {
            this.chartDataArray = this.dynamicChartDataService.setDynamicChartDataArray(
              this.title,
              randomValue ?? 0,
              data.filters,
            );
          },
          error: (error) => {
            this.error = 'Error fetching chart data';
            console.error('Error fetching chart data:', error.message);
          },
        }),
    );
    return;
  }

  joinUrl(urlParams: string, params: string): string {
    console.log('joinUrl input:', { urlParams, params });
    // Remove pageNumber parameter from urlParams
    // This handles cases like:
    // 1. pageNumber=X&otherParam=Y (middle of string)
    // 2. pageNumber=X (only parameter)
    // 3. otherParam=Y&pageNumber=X (end of string)
    const cleanUrlParams = urlParams
      .replace(/([?&])pageNumber=[^&]+(&|$)/g, (match, prefix, suffix) => {
        // If this is the only parameter or last parameter, remove it completely
        if (match.endsWith('&')) {
          return prefix; // Keep the prefix (? or &) for the next parameter
        } else if (suffix === '') {
          return ''; // If it's the last parameter, remove it including the connector
        } else {
          return prefix; // Replace with just the prefix
        }
      })
      .replace(/\?$/g, '');

    // Log after cleaning
    console.log('cleanUrlParams:', cleanUrlParams);

    let result;
    if (cleanUrlParams.includes('?')) {
      result = cleanUrlParams + '&' + params;
    } else if (params) {
      result = cleanUrlParams + '&' + params;
    } else {
      result = cleanUrlParams;
    }
    // Log the result
    console.log('joinUrl result:', result);
    return result;
  }
}
